import { AlignmentType, convertInchesToTwip, LevelFormat, Packer, Document, SectionType, BorderStyle, WidthType, TextRun, Paragraph, TableCell, TableRow, Header, Table, Footer, PageNumber, TableOfContents, TableLayoutType, HeadingLevel, TabStopType, PageOrientation, TextDirection, ShadingType, HeightRule, ImageRun, VerticalAlign } from 'docx';
import { url } from '../../../../../constants/url';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { reportAppName, auditReportTable } from './Part1/Page1-Support';
import { documentDistribution, documentHistory, documentPreparation, page2Heading } from './Part1/Page2-Support';
import { TOCHeadings } from '../../Web/AuditReport/Part1/Page3-Support';
import { introductionBulletOne, introductionBulletThree, introductionBulletTwo, introductionText1 } from './Part1/Page4-Support';
import { scope } from './Part1/Page5-Support';
import { team } from './Part1/Page6-Support';
import { auditActivities, auditActivities1, auditPoint1, auditPoint10, auditPoint2, auditPoint3, auditPoint4, auditPoint5, auditPoint6, auditPoint7, auditPoint8, auditPoint9, timeline1, timelines } from './Part2/page7-Support';
import { OWASP, owaspheading, owaspText, owaspTop10, owaspTop10heading, referenceText } from './Part2/Page8-Support';
import { accrualPhase, accrualPhasebullet1, accrualPhasebullet2, accrualPhasebullet3, accrualPhaseText, Methodology } from '../../Web/AuditReport/Part2/Page8-Support';
import { acclimatizePhase, acclimatizePhaseText, admittancePhase, admittancePhaseText, affirmationPhase, affirmationPhaseText, analysisPhase, analysisPhaseText, } from '../../Web/AuditReport/Part2/Page9-Support';
import { recommendationBulletOne, recommendationBulletTwo, sumaryText2, SummaryRecommendation, summaryText, summaryText1, summaryUserRoles } from './Part2/Page11-Support'
import { tools } from './Part2/Page10-Support';
import { chartTextowasp } from './Part3/Page12-Support';
import { cvssMapping, cvssMappingTable, determination, determination1, determination2 } from '../../Web/AuditReport/Part2/Page11-Support';
import { exploitation, exploitationTable, riskRating, riskRatingTable } from '../../Web/AuditReport/Part3/Page12-Support';
import { graphText, graphText1, severityLevelTable, tableText } from '../../Web/AuditReport/Part3/Page13-Support';
import { observation1, observation2, observation3 } from '../../Web/AuditReport/Part3/Page14-Support';
import { complianceTable } from './Part3/Page18-Support';
import { appendicesTable, auditTools } from './Part3/Page19-Support';



export async function MobileAuditReportSkeleton(props) {
    const {
        date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount, brokenAccess,
        cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures,
        securityFailures, ssrf, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl, appDiscription
    } = props
    const reportName = `${applicationName} Application Penetration Testing Report`


    // page 1 Details
    const page11 = reportAppName(applicationName)
    const page12 = auditReportTable(date, testStartDate, testEndDate)

    // page 2 Details
    const page21 = page2Heading
    const page22 = documentPreparation(date, applicationName)
    const page23 = documentHistory(date)
    const page24 = documentDistribution()


    //page 3 Details
    const page31 = TOCHeadings

    // page 4 Details
    const page41 = introductionText1(applicationName)
    const page42 = introductionBulletOne(applicationName)
    const page43 = introductionBulletTwo
    const page44 = introductionBulletThree

    // page 5 details
    const page51 = scope(applicationURL, appDiscription,) /* here  add the criticality*/

    // page 6 Details
    const page61 = team

    // page 7 Details
    const page71 = auditActivities
    const page72 = auditActivities1
    const page73 = auditPoint1
    const page74 = auditPoint2
    const page75 = auditPoint3
    const page76 = auditPoint4
    const page77 = auditPoint5
    const page78 = auditPoint6
    const page79 = auditPoint7
    const page80 = auditPoint8
    const page711 = auditPoint9
    const page712 = auditPoint10
    const page713 = timelines
    const page714 = timeline1(testStartDate, testEndDate)

    // page 8 Details
    const page81 = owaspheading
    const page82 = owaspText
    const page83 = referenceText
    const page84 = owaspTop10heading
    const page85 = OWASP

    // page 9 Details
    const page91 = Methodology
    const page92 = accrualPhase
    const page93 = accrualPhaseText
    const page94 = accrualPhasebullet1
    const page95 = accrualPhasebullet2
    const page96 = accrualPhasebullet3
    const page97 = acclimatizePhase
    const page98 = acclimatizePhaseText
    const page99 = analysisPhase
    const page100 = analysisPhaseText
    const page911 = admittancePhase
    const page912 = admittancePhaseText
    const page913 = affirmationPhase
    const page914 = affirmationPhaseText

    // page 10 Details
    const page101 = tools

    // page 11 details
    const page111 = summaryText(customerName, applicationName)
    const page112 = summaryText1
    const page113 = sumaryText2(environmentType, testingType)
    const page114 = summaryUserRoles(testingType === "Black box testing methodology (Unauthenticated Testing)" ? " " : userRoles)
    const page115 = SummaryRecommendation
    const page116 = recommendationBulletOne
    const page117 = recommendationBulletTwo

    // page 12 Details
    // const page121 = chartTextowasp

    // page 12 Details
    const page121 = determination  /* this is imported from web audit report page11 */
    const page122 = determination1 /* this is imported from web audit report page11 */
    const page123 = determination2 /* this is imported from web audit report page11 */
    const page124 = cvssMapping /* this is imported from web audit report page11 */
    const page125 = cvssMappingTable /* this is imported from web audit report page11 */

    // page 13 details
    const page131 = riskRating
    const page132 = riskRatingTable       /* this entire page imported from the web audit page 12 */
    const page133 = exploitation
    const page134 = exploitationTable

    // page 14 Details
    const page141 = graphText
    const page142 = tableText     /* this entire page imported from the web audit page 13 */
    const page143 = severityLevelTable(critical, high, medium, low, info)
    const page144 = graphText1

    // page 15 details 
    const page151 = observation1
    const page152 = observation2
    const page153 = observation3

    // page 18 details
    const page181 = complianceTable

    // page 19 details
    const page191 = auditTools
    const page192 = appendicesTable

    const design = {
        page: {
            margin: { top: 500, right: 700, left: 750, header: 870, footer: 850 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }
    const heading1 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400, },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Introduction",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading2 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Engagement Scope",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading3 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Details of the Auditing team",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading4 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Audit Activities and Timelines",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading5 = new Paragraph({

        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Audit Methodology and Criteria / Standard referred for audit",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading6 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Tools/ Software used",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading7 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Executive Summary",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    // const heading8 = new Paragraph({
    //     alignment: AlignmentType.CENTER,
    //     indent: { left: 600 },
    //     spacing: { before: 350, after: 400 },
    //     numbering: { reference: "my-crazy-numbering", level: 0 },
    //     tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    //     children: [
    //         new TextRun({
    //             text: "Benchmarking with OWASP TOP 10",
    //             size: 40,
    //             color: "2F5496",
    //             font: "Arial",
    //             bold: true,
    //             italics: false,
    //             allCaps: false
    //         })
    //     ],
    //     heading: HeadingLevel.HEADING_1,
    // })
    const heading8 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Detailed Observation",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading9 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methods of verification to compliance with CERT-In Directions",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const heading10 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Appendices",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const rows = [
        new TableRow({
            height: { value: 3000, rule: HeightRule.EXACT },
            children: [
                new TableCell({
                    width: { size: 600, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Affected Asset i.e. IP/URL/Application etc.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Observation/Vulnerability title",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 800, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "CVE/CWE",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT,
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 2500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1200, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Reference",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "New or Repeat observation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ],
        }),
    ];
    const sortedVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    sortedVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";
            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "CRITICAL";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "HIGH";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "MEDIUM";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "LOW";
                color = "ffff00";
            } else {
                severity = "INFORMATIONAL";
                color = "00b050";
            }
            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);
        rows.push(
            new TableRow({

                children: [
                    new TableCell({
                        width: { size: 600, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1700, type: WidthType.DXA },
                        children: vulnerability.affectedParameter.split(/\s+/).map((url) =>
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: url,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ),
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1500, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `CWE - ${vulnerability.cveId}`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],


                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 200, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 140, right: 140, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 2700, type: WidthType.DXA },
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 550, right: 50, top: 50, bottom: 50 },
                                    bullet: { level: 0 },
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Arial",
                                            size: 22,
                                            color: "000000",
                                            bold: false,
                                        }),
                                    ],
                                }),
                            )

                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1300, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: "New",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ],
            }),
        )
    });
    const MAX_WIDTH = 670;
     const MAX_HEIGHT = 380;

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

   const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;

                // Calculate scaling factors for width and height
                const widthScale = MAX_WIDTH / width;
                const heightScale = MAX_HEIGHT / height;

                // Use the smaller scaling factor (to stay within both bounds)
                const scale = Math.min(widthScale, heightScale, 1);

                width = width * scale;
                height = height * scale;

                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            const dimensions = await getImageDimensions(imageData);
            return new ImageRun({
                data: imageData,
                transformation: { width: dimensions.width, height: dimensions.height },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    const sortVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    const docSections = sortVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            combinedContent.push(
                new Paragraph({
                    children: [
                        new TextRun({
                            text: `${pocText}`,
                            size: 24,
                            italics: false,
                            bold: false
                        }),
                    ],
                })
            );

            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `❌ Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }

        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Informational";
                color = "00b050";
            }

            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);

        return [
            new Paragraph({
                heading: HeadingLevel.HEADING_1,
                tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
                indent: { left: 500 },
                spacing: { before: 150, after: 400 },
                numbering: { reference: "my-crazy-numbering", level: 1 },
                pageBreakBefore: true,
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false
                    })
                ],
            }),

            new Table({
                width: { size: 10300, type: WidthType.DXA },
                alignment: AlignmentType.CENTER,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({

                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected Asset",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.affectedParameter.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 80, after: 50 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: url,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ),
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Observation/ Vulnerability Title",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Detailed Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.description,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVE/CWE",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: `CWE - ${vulnerability.cveId}`,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Objective",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Name",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Audit Requirement",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Ease of Exploitation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.exploitation,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS String",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },

                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: vulnerability.cvssString,
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            }),
                                        ]
                                    }),
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS Score/ Risk Rating",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: `${riskScore}/${severity}`,
                                            font: "Arial",
                                            size: 24,
                                            color: color,
                                            italics: false,
                                            bold: true,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is Recommended to:",
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            spacing: { before: 50, after: 50 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 700, right: 100 },
                                            bullet: { level: 0 },
                                            children: [new TextRun({
                                                text: bulletText.trim(),
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                            ]
                                        })
                                    )
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: "",
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "New or Repeat Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "New",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({
                // indent: { left: 600 },
                spacing: { before: 200, line: 356 },
                pageBreakBefore: true,
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })


    const docSectionsResolved = await Promise.all(docSections);

    // for vulnerability Table ----end------
    const doc = new Document({
        creator: "manjesh",
        features: { updateFields: true },
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "%1.",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 40,
                                    bold: true,
                                    color: "2F5496",
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "8.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "000000", bold: true, size: 24, font: "Arial" },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "000000",
                                    font: "Arial"
                                },
                            },
                        },

                    ]
                }
            ]
        },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Arial",
                        bold: true,
                        size: 24,
                        color: "000000",
                    },
                },
                heading1: {
                    run: {

                        font: "Arial",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
            },
        },
        sections: [
            {
                properties: { ...design },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                alignment: AlignmentType.RIGHT,
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 100, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "<Confidential>",
                                                                size: 24,
                                                                font: "Arial",
                                                                color: '000000',
                                                                bold: false
                                                            })
                                                        ]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                margin: { top: 600 },
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 5, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Page",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 18, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),

                                                            new TextRun({
                                                                text: " of ",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),

                                                            new TextRun({
                                                                children: [PageNumber.TOTAL_PAGES],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),

                                            new TableCell({
                                                width: { size: 77, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Cert-In Audit report format: Version 1.0",
                                                                font: "Calibri",
                                                                size: 24,
                                                                italics: false,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ]
                                    })
                                ]

                            })
                        ]
                    })
                },
                children: [page11, page12],
                pageBreakBefore: true

            },

            //---------------------- page 2 Start----------------------
            {
                properties: { ...design },
                children: [page21, page22, new Paragraph({ spacing: { after: 600 }, }), page23, new Paragraph({ spacing: { after: 600 } }), page24,],
                pageBreakBefore: true
            },
            //---------------------- page 2 End----------------------
            //---------------------- page 3 Start----------------------
            {
                properties: { ...design },
                children: [page31,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        rows: [
                            new TableRow({

                                children: [
                                    new TableCell({
                                        width: { size: 100, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),],
                pageBreakBefore: true
            },
            //---------------------- page 3 End----------------------
            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [heading1, page41, page42, page43, page44],
                pageBreakBefore: true

            },
            //---------------------- page 4 End----------------------
            //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [heading2, page51],
                pageBreakBefore: true
            },
            //---------------------- page 5 End----------------------
            //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [heading3, page61],
                pageBreakBefore: true
            },
            //---------------------- page 6 End----------------------
            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [heading4, page71, page72, page73, page74, page75, page76, page77, page78, page79, page80, page711, page712, page713, page714,],
                pageBreakBefore: true
            },
            //---------------------- page 7 End----------------------
            //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [heading5, page81, page82, page83, page84, page85],
                pageBreakBefore: true
            },
            //---------------------- page 8 End----------------------
            //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [page91, page92, page93, page94, page95, page96, page97, page98, page99, page100, page911, page912, page913, page914],
                pageBreakBefore: true
            },
            //---------------------- page 9 End----------------------
            //---------------------- page 10 Start----------------------
            {
                properties: { ...design },
                children: [heading6, page101],
                pageBreakBefore: true
            },
            //---------------------- page 10 End----------------------
            //---------------------- page 11 Start----------------------
            {
                properties: { ...design },
                children: [heading7, page111, page112, page113, page114, page115, page116, page117],
                pageBreakBefore: true
            },
            //---------------------- page 11 End----------------------
            //---------------------- page 12 Start----------------------
            {
                properties: { ...design },
                children: [page121, page122, page123, page124, page125,],
                pageBreakBefore: true
            },
            //---------------------- page 12 End----------------------
            //---------------------- page 13 Start----------------------
            {
                properties: { ...design },
                children: [page131, page132, page133, page134,],
                pageBreakBefore: true
            },
            //---------------------- page 13 End----------------------
            //---------------------- page 14 Start----------------------
            {
                properties: { ...design },
                children: [page141, page142, page143, page144],
                pageBreakBefore: true
            },
            //---------------------- page 14 End----------------------
            //---------------------- page 15 Start----------------------
            {
                properties: { ...design },
                children: [new Paragraph({}),
                new Table({
                    width: { size: 10335, type: WidthType.DXA },
                    layout: TableLayoutType.FIXED,
                    alignment: AlignmentType.CENTER,

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    },
                    rows: rows
                })],
                pageBreakBefore: true
            },
            //---------------------- page 15 End----------------------
            //---------------------- page 16 Start----------------------
            {
                properties: { ...design },
                children: [heading8, page151, page152, page153],
                pageBreakBefore: true
            },
            //---------------------- page 16 End----------------------
            //---------------------- page 17 Start----------------------

            {
                properties: { ...design },
                children: [...docSectionsResolved.flat()],
                pageBreakBefore: true
            },
            //---------------------- page 17 End----------------------
            //---------------------- page 18 Start----------------------
            {
                properties: { ...design },
                children: [heading9, page181],
                pageBreakBefore: true
            },
            //---------------------- page 18 End----------------------
            //---------------------- page 19 Start----------------------
            {
                properties: { ...design },
                children: [heading10, page191, page192],
                pageBreakBefore: true
            }
            //---------------------- page 19 End----------------------
        ]


    })

    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            });
            return
        }

    } catch (error) {
        console.log(error)
    }
}